import axiosInstance from "../../Shared/Utils/axiosInstance";
import {
  getNotificationsFromServer,
  fetchTopAshaTableDetails,
  AshaDeployedByRegion,
  fetchTotalAsha,
  fetchTotalAsha_V2,
} from "../../Services/DashboardService";
import { TokenDecrypt } from "../../Shared/Utils/encryptionDecryption";
export const FETCH_OVERVIEW_DETAILS = "FETCH_OVERVIEW_DETAILS";
export const FETCH_OVERVIEW_SUCCESS = "FETCH_OVERVIEW_SUCCESS";
export const FETCH_OVERVIEW_ERROR = "FETCH_OVERVIEW_ERROR";
export const SET_AREA_TYPE = "SET_AREA_TYPE";
export const TOTAL_ASHA = "TOTAL_ASHA";
export const TOTAL_ASHA_SUCCESS = "TOTAL_ASHA_SUCCESS";
export const TOTAL_ASHA_FAILURE = "TOTAL_ASHA_FAILURE";
export const FETCH_TOP_ASHA_TABLE_DETAILS = "FETCH_TOP_ASHA_TABLE_DETAILS";
export const FETCH_TOP_ASHA_TABLE_DETAILS_SUCCESS =
  "FETCH_TOP_ASHA_TABLE_DETAILS_SUCCESS";
export const FETCH_TOP_ASHA_TABLE_DETAILS_FAILURE =
  "FETCH_TOP_ASHA_TABLE_DETAILS_FAILURE";
export const FETCH_NOTIFICATION = "FETCH_NOTIFICATION";
export const FETCH_NOTIFICATION_SUCCESS = "FETCH_NOTIFICATION_SUCCESS";
export const FETCH_NOTIFICATION_FAILURE = "FETCH_NOTIFICATION_FAILURE";
export const SET_DISTRICT_ID = "SET_DISTRICT_ID";
export const SET_DISTRICT_ID_FAILURE = "SET_DISTRICT_ID_FAILURE";
export const FETCH_DISTRICT_ID = "FETCH_DISTRICT_ID";
export const SET_TALUKA_ID = "SET_TALUKA_ID";
export const SET_TALUKA_ID_FAILURE = "SET_TALUKA_ID_FAILURE";
export const SEND_TALUKA_ID = "SEND_TALUKA_ID";
export const SEND_PHC_ID = "SEND_PHC_ID";
export const SET_PHC_ID = "SET_PHC_ID";
export const SET_PHC_ID_FAILURE = "SET_PHC_ID_FAILURE";
export const FETCH_ASHA_DEPLOYED_BY_REGION = "FETCH_ASHA_DEPLOYED_BY_REGION";
export const FETCH_ASHA_DEPLOYED_BY_REGION_SUCCESS =
  "FETCH_ASHA_DEPLOYED_BY_REGIONS_SUCCESS";
export const FETCH_ASHA_DEPLOYED_BY_REGION_FAILURE =
  "FETCH_ASHA_DEPLOYED_BY_REGIONS_FAILURE";
export const setAreaType = (type) => {
  return (dispatch) => {
    dispatch({ type: SET_AREA_TYPE, payload: type });
  };
};
export const fetchDistrictId = (type) => {
  return (dispatch) => {
    dispatch({ type: FETCH_DISTRICT_ID, payload: type });
  };
};
export const SendTaluka = (type) => {
  return (dispatch) => {
    dispatch({ type: SEND_TALUKA_ID, payload: type });
  };
};
export const SendPHC = (type) => {
  return (dispatch) => {
    dispatch({ type: SEND_PHC_ID, payload: type });
  };
};

export const setTalukaId = (selectedDistrict, selectedLanguageId) => {
  const reqBody = {
    districtIds: selectedDistrict,
  };

  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `/api/talukas?languageId=${selectedLanguageId}`,
        reqBody
      );
      dispatch({ type: SET_TALUKA_ID, payload: response.data });
    } catch (error) {
      dispatch({
        type: SET_TALUKA_ID_FAILURE,
        payload: error.message || "Failed to fetch taluka data",
      });
    }
  };
};
export const setPHCId = (selectedTaluka, selectedLanguageId) => {
  const reqBody = {
    talukaIds: selectedTaluka,
  };
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `/api/phcs?languageId=${selectedLanguageId}`,
        reqBody
      );
      dispatch({ type: SET_PHC_ID, payload: response.data });
    } catch (error) {
      dispatch({
        type: SET_PHC_ID_FAILURE,
        payload: error.message || "Failed to fetch taluka data",
      });
    }
  };
};
export const setDistrictId = (selectedLanguageId) => {
  const reqBody = {
    stateId: 1,
  };
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post(
        `/api/districts?languageId=${selectedLanguageId}`,
        reqBody
      );
      dispatch({ type: SET_DISTRICT_ID, payload: response.data });
    } catch (error) {
      dispatch({
        type: SET_TALUKA_ID_FAILURE,
        payload: error.message || "Failed to fetch district data",
      });
    }
  };
};
export const fetchOverviewDetails = (areaType) => {
  return (dispatch) => {
    dispatch({ type: FETCH_OVERVIEW_DETAILS });
    dispatch({ type: FETCH_OVERVIEW_SUCCESS });
  };
};
export const fetchTotalTableDetails = (
  areaTypeId,
  selectedLanguageId,
  district,
  taluka,
  roles,
  month,
  year
) => {
  return async (dispatch) => {
    try {
      const data = await fetchTopAshaTableDetails(
        areaTypeId,
        selectedLanguageId,
        district,
        taluka,
        roles,
        month,
        year
      );
      const decrypt = TokenDecrypt(data);
      dispatch({
        type: FETCH_TOP_ASHA_TABLE_DETAILS_SUCCESS,
        payload: decrypt,
      });
    } catch (error) {
      dispatch({
        type: FETCH_TOP_ASHA_TABLE_DETAILS_FAILURE,
        payload: error.message,
      });
    }
  };
};

export const fetchNotifications = () => async (dispatch) => {
  dispatch({ type: FETCH_NOTIFICATION });
  try {
    const response = await getNotificationsFromServer();
    dispatch({
      type: FETCH_NOTIFICATION_SUCCESS,
      payload: response.data.notifications,
    });
  } catch (error) {
    dispatch({
      type: FETCH_NOTIFICATION_FAILURE,
      payload: error.message,
    });
  }
};

export const fetchAshaDeployedByRegion = (chosenMonth, chosenYr) => {
  return async (dispatch) => {
    try {
      const data = await AshaDeployedByRegion(chosenMonth, chosenYr);
      dispatch({
        type: FETCH_ASHA_DEPLOYED_BY_REGION_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_ASHA_DEPLOYED_BY_REGION_FAILURE,
        payload: error.message,
      });
    }
  };
};

export const fetchTotalTopAsha = (areatype, selectedLanguage,status) => {
  return async (dispatch) => {
    try {
      const data = await fetchTotalAsha(
        areatype,
        selectedLanguage,
        status
      );
      dispatch({
        type: TOTAL_ASHA_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: TOTAL_ASHA_FAILURE,
        payload: error.message,
      });
    }
  };
};
export const fetchTotalTopAsha_V2 = (areatype, selectedLanguage,status,page,pageSize,filters) => {
  return async (dispatch) => {
    try {
      const totalAshaData = await fetchTotalAsha_V2(
        areatype,
        selectedLanguage,
        status,
        page,
        pageSize,filters
      );
      dispatch({
        type: TOTAL_ASHA_SUCCESS,
        payload: totalAshaData?.data,
        paginationData: 
        { totalCount: totalAshaData?.totalCount || 0, 
          page: totalAshaData?.page || 1,
          pageSize: totalAshaData?.pageSize || 10
        }
      });
    } catch (error) {
      dispatch({
        type: TOTAL_ASHA_FAILURE,
        payload: error.message,
      });
    }
  };
};
